import { InputLabel as MuiInputLabel } from '@mui/material';
import { InputLabelProps } from './InputLabel.props';

export const InputLabel = ({ children, ...props }: InputLabelProps) => {
  return <MuiInputLabel {...props}>{children}</MuiInputLabel>;
};

export default InputLabel;
